import getRoute from '@pro/common/utils/getRoute';
import getPagePermission from '@pro/common/utils/getPagePermission';
import { PUBLIC } from '@pro/common/config/page-permission';
import { REDIRECT_PATH } from '@pro/common/router/guard/redirects';

/** @typedef {import('../declarations/page-permission').PagePermission} PagePermission */

/**
 * 判断指定路由是否是公共页面
 * @param {string=} path
 * @returns {PagePermission=}
 */
const isPublicPage = (path) => {
  path = path ?? getRoute().path;
  return getPagePermission(path, [...PUBLIC, ...REDIRECT_PATH]);
};

export default isPublicPage;
